import Constants from '@helpers/Constants';

export enum AuthRoute {
  Start = 'StartScreen',
  Login = 'LoginScreen',
  Register = 'RegisterScreen',
  ResetPassword = 'ResetPasswordScreen',
}

export enum CommonRoute {
  CurrentUserProfile = 'CurrentUserProfileScreen',
  Profile = 'ProfileScreen',
  ViewPlan = 'ViewPlanScreen',
  Notifications = 'NotificationsScreen',
  ChatThreads = 'ChatThreadsScreen',
  Chat = 'ChatScreen',
  CreateChat = 'CreateChatScreen',
  UpdatePlan = 'UpdatePlanScreen',
  ViewFollows = 'ViewFollowsScreen',
  ViewGroup = 'ViewGroupScreen',
  ViewGroupMembers = 'ViewGroupMembersScreen',
  UpdateGroup = 'UpdateGroupScreen',
  CreateGroup = 'CreateGroupScreen',
  InviteContacts = 'InviteContactsScreen',
  Settings = 'SettingsScreen',
  UpdateUser = 'UpdateUserScreen',
}

export enum FollowUsersRoute {
  FollowUsers = 'FollowUsersScreen',
}

export enum GroupRoute {
  ViewGroups = 'ViewGroupsScreen',
}

export enum HomeRoute {
  Home = 'HomeScreen',
}

export enum OnboardedStackRoute {
  OnboardedTab = 'OnboardedTab',
  CreatePlan = 'CreatePlanScreen',
}

export enum OnboardedTabRoute {
  Home = 'Home',
  FollowUsers = 'FollowUsers',
  Groups = 'Groups',
  CreatePlan = 'CreatePlan',
}

export enum OnboardingRoute {
  CreateUser = 'CreateUserScreen',
  FollowUsers = 'FollowUsersScreen',
  RequestPermissions = 'RequestPermissionsScreen',
  Welcome = 'WelcomeScreen',
  UserPrivateForm = 'UserPrivateFormScreen',
  JoinGroups = 'JoinGroupsScreen',
}

export enum AppLinkPath {
  Chat = 'chats/:chatId',
  Chats = 'chats',
  CreateChat = 'chats/new',
  CreateGroup = 'groups/new',
  CreatePlan = 'plans/new',
  CurrentUserProfile = 'you',
  EditCurrentUser = 'you/edit',
  EditGroup = 'groups/:groupId/edit',
  EditPlan = 'plans/:planId/edit',
  Group = 'groups/:groupId',
  GroupMembers = 'groups/:groupId/members',
  Groups = 'groups',
  Home = '',
  InviteContacts = 'invite-contacts',
  Login = 'login',
  Notifications = 'notifications',
  OnboardingCreateUser = 'onboarding/profile',
  OnboardingFollowUsers = 'onboarding/people',
  OnboardingJoinGroups = 'onboarding/groups',
  OnboardingPermissions = 'onboarding/permissions',
  OnboardingPrivateProfile = 'onboarding/private-profile',
  OnboardingWelcome = 'onboarding/welcome',
  People = 'people',
  Plan = 'plans/:planId',
  Register = 'register',
  ResetPassword = 'reset-password',
  Settings = 'settings',
  User = 'users/:userId',
  UserFollows = 'users/:userId/follows',
}

export const UNIVERSAL_LINK_PREFIX = Constants.joinstar.company.links.app;
